<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator">
        <v-btn
          :text="!notIcon"
          :icon="!notIcon"
          @click="openModal"
          v-bind="attrs" v-on="on"
          :class="btnClass ? btnClass : ''"
        >
          <slot name="icon">
            <IconTimeControlBill icon="green"/>
          </slot>
        </v-btn>
      </slot>
    </template>
    <transition-group v-if="dialog" :duration="150">
      <PDFJSViewer key="PDFJSViewer" :url="apiDomain + '/' + url" />
      <div class="modal_buttons" key="buttons">
        <slot name="button"></slot>
        <BaseButton
          @click="closeModal"
          default_icon="button-back"
          :text="localStorage.translations.pages.common['buttons']['nazad']"
        />
      </div>
    </transition-group>
  </v-dialog>
</template>

<script>
import PDFJSViewer from 'components/PDFJSViewer'
import IconTimeControlBill from "../icons/timeControl/IconTimeControlBill";

export default {
  name: 'PdfModalShow',
  components: {
    IconTimeControlBill,
    PDFJSViewer,
  },
  props: ['id', 'url', 'btnClass', 'notIcon'],
  data() {
    return {
      dialog: false,
    }
  },
  watch: {},
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
}
</script>

<style lang="scss" scoped>
.modalBody {
  width: 100%;
  height: 100vh;
}
.customBtn {
  padding: 15px !important;
  text-transform: capitalize;
}
.modal_buttons {
  display: grid;
  gap: 10px;
  justify-items: flex-end;
  position: fixed;
  right: 25px;
  bottom: 10%;
}

</style>
